export default __webpack_public_path__ + "5bd9426cc284631aedc8bcbebda48609.svg";